package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.AppointmentStatus
import br.com.heyagenda.domain.repository.AppointmentRepository

class UpdateAppointmentStatusUseCase(
    private val repository: AppointmentRepository
) {
    suspend operator fun invoke(appointmentId: String, status: AppointmentStatus): Result<Unit> {
        return repository.updateAppointmentStatus(appointmentId, status)
    }

    suspend fun completeWithPayment(appointmentId: String, paymentMethod: String): Result<Unit> {
        return repository.completeAppointment(appointmentId, paymentMethod)
    }

    suspend fun updatePaymentMethod(appointmentId: String, paymentMethod: String): Result<Unit> {
        return repository.updateAppointmentPaymentMethod(appointmentId, paymentMethod)
    }
}
